// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipOverlay_tooltip__bV3pM","close":"TooltipOverlay_close__fuQfj"};